<div>
  <sc-flex>
    <div *ngFor="let inclusion of condition.inclusions">
      <div>{{inclusion}}</div>
    </div>
    <div *ngFor="let exclusions of condition.exclusions">
      <div>{{exclusions}}</div>
    </div>
    <sc-action-icon iconClass="fa-trash" (click)="onDelete()"></sc-action-icon>
  </sc-flex>
</div>